import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import logo from '../img/pt-logo.svg';

export default withRouter(({location, showMenu}) => (
    <div className='title'>
        <Link to='/'>	
            <div className="title__logo">
                <img src={logo} style={{objectFit: 'contain'}} alt=""/>
            </div>
        </Link>
        { ['/', '/info'].includes(location.pathname) && <p>scientist | artist</p> } 
        <div className="title__menu-icon" onClick={() => showMenu(true)}>
            <FontAwesomeIcon icon={faEllipsisV}/>
        </div>
    </div>    
))


// WEBPACK FOOTER //
// ./src/components/Title.js